import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactGA from "react-ga4";
import CruiseFilter from "./CruiseFilter";
import virginLogo from "../../assets/virginLogo.png";
import CruiseGridTile from "./CruiseGridTile";

import "./GridCruiseList.css";

function GridCruiseList({ onInquireClick, onDetailsClick }) {
  const [sort, setSort] = useState("CurrentPriceAdv");
  const [sortOrder, setSortOrder] = useState("neutral");
  const [currentPage, setCurrentPage] = useState(1);
  const [overlayTop, setOverlayTop] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "GroupRate",
    direction: "default", // can be 'asc', 'desc', or 'default'
  });
  const [cruiseDetailModalOpen, setCruiseDetailModalOpen] = useState(false);
  const [cruiseUnavailableModalOpen, setCruiseUnavailableModalOpen] =
    useState(false);
  useState(false);
  const [shipDetailModalOpen, setShipDetailModalOpen] = useState(false);
  const [cruisePerksModalOpen, setCruisePerksModalOpen] = useState(false);
  const [currentCruiseShip, setCurrentCruiseShip] = useState(null);
  const [currentOperator, setCurrentOperator] = useState(null);
  const [sailDateForPerks, setSailDateForPerks] = useState(null);

  const dispatch = useDispatch();
  const cruises = useSelector((state) => state.cruises.cruisesList);

  const [sailDateForCruiseDetail, setSailDateForCruiseDetail] = useState();
  const [shipNameForCruiseDetail, setShipNameForCruiseDetail] = useState();

  const rowRefs = useMemo(() => {
    return cruises ? cruises.map(() => React.createRef()) : [];
  }, [cruises]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shipDetailModalOpen && !event.target.closest(".popup")) {
        toggleShipDetailModal(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [sort, sortOrder, setShipDetailModalOpen]);

  const toggleSortOrder = (currentOrder) => {
    switch (currentOrder) {
      case "neutral":
        return "asc";
      case "asc":
        return "desc";
      case "desc":
        return "neutral";
      default:
        return "neutral";
    }
  };

  // Render logo for each cruise line (just Celeb and Royal atm)
  function getLogoByCruiseLine(cruiseLine) {
    switch (cruiseLine) {
      case "Virgin Voyages":
        return virginLogo;
      default:
        return virginLogo; // or some default logo if needed
    }
  }

  function toggleShipDetailModal(show) {

    // ReactGA.event({
    //   event: "cruise_search",
    //   category: "Search",
    //   action: "Clicked Ship Detail",
    // });

    setShipDetailModalOpen(show);
  }

  function toggleCruiseUnavailableModal(show) {
    setCruiseUnavailableModalOpen(show);
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <br />

      {/* CruiseFilter */}
      <CruiseFilter
        onPageChange={handlePageChange}
        sortOrder={sortOrder}
        sort={sort}
      />
      <div className="flex justify-center items-center pr-2 sm:hidden mt-4 mb-4">
        <div className="pl-2 pr-4">
          <label
            className="block text-sm font-semibold text-gray-900"
            htmlFor="sort">
            Sort:
          </label>
        </div>
        {/* Mobile sorting options */}
        <select
          id="sort"
          name="sort"
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          onChange={(e) => {
            const value = e.target.value;
            if (value !== sort) {
              setSort(value);
              setSortOrder("asc");
            } else {
              setSortOrder(toggleSortOrder(sortOrder));
            }
          }}>
          <option value="SailDate">Duration & Sail Date</option>
          <option value="CurrentGroupRate">Market Price</option>
          <option value="GroupRate">Our Price</option>
          <option value="CurrentPriceAdv">Savings</option>
        </select>
      </div>

      {/* New grid stuff */}
      <div className="mt-8 cruise-grid">
        {cruises && cruises.length > 0 ? (
          cruises.map((cruise, index) => {
            return (
              <CruiseGridTile
                key={cruise.CombinedKey}
                cruise={cruise}
                onInquireClick={onInquireClick}
                className={index % 2 === 0 ? "even-row" : ""}
              />
            );
          })
        ) : (
          <h1 className="text-base font-semibold leading-6 text-">
            No Cruises Available.
          </h1>
        )}
      </div>
    </div>
  );
}

export default React.memo(GridCruiseList);
